import WidgetFinance from 'components/Widgets/WidgetFinance';

const FinanceTypeField = ({ item, selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetFinance
      item={item}
      value={selectItem ?? {}}
      onChange={(val) =>
        setNewSelectItem({
          value: val.result ?? ' ',
          setting: val,
        })
      }
      disabled={disabled}
    />
  );
};

export default FinanceTypeField;
